import { Grid } from "@mui/material";
import EmailInput from "../../../../../../components/inputs/email/emailInput";
import EndOfQualification from "../../../../../../components/inputs/endOfQualification/endOfQualificationInput";
import FirstNameInput from "../../../../../../components/inputs/firstName/firstNameInput";
import LastNameInput from "../../../../../../components/inputs/lastName/lastNameInput";
import LocationInput from "../../../../../../components/inputs/location/locationInput";
import PhoneNumberInput from "../../../../../../components/inputs/phoneNumber/phoneNumberInput";
import QualificationInput from "../../../../../../components/inputs/qualification/qualificationInput";
import StartOfQualification from "../../../../../../components/inputs/startOfQualification/startOfQualificationInput";
import { EditUserProps } from "../../../../interfaces/interfaces";

const RenderForm = ({
  editUser,
  setEditUser,
}: {
  editUser: EditUserProps;
  setEditUser: React.Dispatch<EditUserProps>;
}): React.JSX.Element => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <FirstNameInput
          firstName={editUser.participant.firstName}
          setFirstName={(newFirstName: string) => {
            setEditUser({
              ...editUser,
              participant: {
                ...editUser.participant,
                firstName: newFirstName,
              },
            });
          }}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <LastNameInput
          lastName={editUser.participant.lastName}
          setLastName={(newLastName: string) => {
            setEditUser({
              ...editUser,
              participant: {
                ...editUser.participant,
                lastName: newLastName,
              },
            });
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <QualificationInput
          required
          qualification={editUser.participant.qualification}
          setQualification={(newQualification: string) => {
            setEditUser({
              ...editUser,
              participant: {
                ...editUser.participant,
                qualification: newQualification,
              },
            });
          }}
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <StartOfQualification
          required
          startOfQualification={editUser.participant.startOfQualification}
          endOfQualification={editUser.participant.endOfQualification}
          setStartOfQualification={(startOfQualification: string) => {
            setEditUser({
              ...editUser,
              participant: {
                ...editUser.participant,
                startOfQualification: startOfQualification,
              },
            });
          }}
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <EndOfQualification
          required
          endOfQualification={editUser.participant.endOfQualification}
          startOfQualification={editUser.participant.startOfQualification}
          setEndOfQualification={(endOfQualification: string) => {
            setEditUser({
              ...editUser,
              participant: {
                ...editUser.participant,
                endOfQualification: endOfQualification,
              },
            });
          }}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <LocationInput
          location={{
            label: editUser.participant.location,
            value: editUser.participant.locationId,
          }}
          setLocation={(newLocation: any) =>
            setEditUser({
              ...editUser,
              participant: {
                ...editUser.participant,
                location: newLocation.label,
                locationId: newLocation.value,
              },
            })
          }
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <EmailInput
          email={editUser.participant.email}
          setEmail={(newEmail: string) => {
            setEditUser({
              ...editUser,
              participant: {
                ...editUser.participant,
                email: newEmail,
              },
            });
          }}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <PhoneNumberInput
          phoneNumber={editUser.participant.phoneNumber.replace(/\s/g, "")}
          setPhoneNumber={(newPhoneNumber: string) => {
            setEditUser({
              ...editUser,
              participant: {
                ...editUser.participant,
                phoneNumber: newPhoneNumber,
              },
            });
          }}
        />
      </Grid>
    </Grid>
  );
};

export default RenderForm;
